import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { bubbleBackgroundColor } from '@/theme';
import { desktopMediaQuery, tabletMediaQuery } from '@/utils/mediaQuery';

const isDesktop = `@media ${desktopMediaQuery}`;
const isTablet = `@media ${tabletMediaQuery}`;

const topBubble = {
  width: '200px',
  height: '200px',
  top: '-70px',
  right: '70px',
};

const bottomBubble = {
  width: '150px',
  height: '150px',
  bottom: '-50px',
  left: '20%',
};

export const Template = styled(Box)({
  display: 'flex',
  maxWidth: '1200px',
  margin: 'auto',
  paddingLeft: 0,
  flexDirection: 'column',
  minHeight: '100vh',
  gap: '24px',
  padding: '16px',

  '::before, ::after': {
    content: '""',
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: bubbleBackgroundColor,
    zIndex: -1,
  },

  '::before': topBubble,

  '::after': bottomBubble,

  [isTablet]: {
    padding: '24px',
  },
  [isDesktop]: {
    paddingLeft: '24px',
    flexDirection: 'row',
  },
});
